import React, { useEffect, useState } from "react";
import api from "../../../../api";
import { useToast } from "../../../../components/toast/toast";
import { Button, Divider, Empty, Flex, InputNumber } from "antd";
import Loader from "../../../../components/spin/Loader";
import { formatCurrency } from "../../../../utilities/utils";
import ConfirmModal from "../../../../components/modal/ConfirmModal";
import { useNavigate } from "react-router-dom";

const LotteryDraw = ({ lotteryId, activeKey }) => {
  const [data, setData] = useState([]);
  const [drawNumberLength, setDrawNumberLength] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [digit, setDigit] = useState({});
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  const toast = useToast();

  const fetchData = async () => {
    setIsLoading(true);
    const res = await api.award_list(lotteryId);
    // console.log("award list --->", res);
    const draw = res.data.data;
    if (res.status === 200) {
      setData(draw.draws);
      setDrawNumberLength(draw.numberLength);
    } else {
      toast(res.data.message || "Алдаа гарлаа", "error");
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (activeKey === "4" && lotteryId) {
      fetchData();
    }
  }, [lotteryId, activeKey]);

  const VerItem = ({ title, value }) => (
    <Flex vertical style={{ marginBottom: 8 }}>
      <p>{title}:</p>
      <strong>{value}</strong>
      <Divider />
    </Flex>
  );

  const DrawWinningNumberHandler = async (id) => {
    const dig = digit[id];
    if (dig === undefined || dig === null || dig === "") {
      return toast("Нэг оронтой тоо оруулна уу!", "warning");
    }

    const res = await api.draw_winning_number(id, {
      digit: String(dig),
    });
    // console.log("res -->", res);
    if (res.status === 200) {
      toast("Амжилттай хадгалагдлаа", "success");
      setDigit((prev) => ({ ...prev, [id]: "" }));
      fetchData();
    } else {
      toast(res.data.message || "Алдаа гарлаа", "error");
    }
  };

  const ResetDrawNumber = async (drawId) => {
    const res = await api.reset_draw_number(drawId);
    if (res.status === 200) {
      toast("Амжилттай", "success");
      setDigit((prev) => ({ ...prev, [drawId]: "" }));
      fetchData();
    } else {
      toast(res.data.message || "Алдаа гарлаа", "error");
    }
  };

  const updateDrawStatusHandler = async (id, status) => {
    const res = await api.update_draw_status(id, status);
    if (res.status === 200) {
      toast("Тохирлын төлөв амжилттай солигдлоо", "success");
      fetchData();
    } else {
      toast(res.data.message || "Алдаа гарлаа", "error");
    }
  };

  const submitHandler = async () => {
    // lotteryId
    const res = await api.update_status_to_completed(lotteryId);
    // console.log("complete res --->", res);
    if (res.status === 200) {
      toast("Сугалаа дууссан төлөвт шилжлээ", "success");
      setVisible(false);
      navigate("/lottery/completed");
    } else {
      toast(res.data.message || "Алдаа гарлаа", "error");
    }
  };

  // if (isLoading) return <Loader />;

  return (
    <Flex vertical gap={"10px"} style={{ padding: "0 0 10px" }}>
      {/* {data?.some((e) => !e.winner_info) &&
        data?.some((e) => e.draw_number) && ( */}
      {data.length > 0 && data.every((e) => e.winner_info?.phone) && (
        <Flex
          align="center"
          justify="space-between"
          style={{
            backgroundColor: "#f9f9f9",
            padding: "15px 20px",
            border: "1px solid #f1f3f4",
            marginBottom: "10px",
          }}
        >
          <p>
            Бүх тохирол явагдаж дууссаны дараа "
            <span style={{ fontWeight: 700 }}>Сугалааг дуусгах</span>" товчыг
            дарна уу!
          </p>
          <Button
            variant="dashed"
            color="primary"
            onClick={() => setVisible(true)}
            style={{ padding: "0px 20px" }}
          >
            Сугалааг дуусгах
          </Button>
        </Flex>
      )}
      {data.length ? (
        data.map((e, i) => (
          <Flex
            vertical
            key={i}
            style={{
              backgroundColor: "#f9f9f9",
              padding: "10px",
              border: "1px solid #f1f3f4",
            }}
            gap={"10px"}
          >
            {e.is_drawing ? (
              <h3 style={{ color: "#0066cc" }}>Идэвхтэй</h3>
            ) : (
              <h4>
                Идэвхгүй{" "}
                <Button
                  color="default"
                  variant="filled"
                  style={{ margin: "0 0 0 5px", border: "1px solid #eee" }}
                  onClick={() => updateDrawStatusHandler(e.id, !e.is_drawing)}
                >
                  Идэвхжүүлэх
                </Button>
              </h4>
            )}
            <Flex gap={"40px"}>
              <Flex vertical style={{ width: "100%" }}>
                <VerItem title="Шагналын нэр" value={e.prize_title} />
                <VerItem
                  title="Шагналын сан"
                  value={formatCurrency(e.prize_amount) || "-"}
                />
                <VerItem title="Азын дугаар" value={e.draw_number || "-"} />
                <VerItem
                  title="Ялагчын утасны дугаар"
                  value={e.winner_info?.phone || "-"}
                />
              </Flex>
              <Flex vertical style={{ width: "100%" }} gap={"40px"}>
                <Flex vertical>
                  <p>Сугалагдсан тоо</p>
                  <Flex align="center" justify="space-between">
                    <Flex gap={"10px"}>
                      <InputNumber
                        min={0}
                        max={9}
                        value={digit[e.id] ?? ""}
                        onChange={(val) => setDigit({ ...digit, [e.id]: val })}
                        placeholder="-"
                      />
                      <Button
                        variant="filled"
                        color="default"
                        style={{ border: "1px solid #eee" }}
                        onClick={() => DrawWinningNumberHandler(e.id)}
                      >
                        Тоог оруулах
                      </Button>
                    </Flex>
                    <Button
                      danger
                      type="primary"
                      onClick={() => ResetDrawNumber(e.id)}
                    >
                      Reset
                    </Button>
                  </Flex>
                </Flex>
                <Flex vertical>
                  <p>Тохиролын явц</p>
                  <Flex style={{ width: "100%", gap: "10px" }}>
                    {(() => {
                      const length = 5;
                      const drawNumber = e.draw_number || "";
                      const chars = drawNumber.split("");
                      while (chars.length < drawNumberLength) {
                        chars.push("");
                      }
                      return chars.map((char, idx) => (
                        <div
                          key={idx}
                          style={{
                            width: "100%",
                            height: "30px",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontSize: "14px",
                            backgroundColor: "#f1f3f4",
                          }}
                        >
                          {char}
                        </div>
                      ));
                    })()}
                  </Flex>
                </Flex>
              </Flex>
            </Flex>
          </Flex>
        ))
      ) : (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={"Шагнал үүсээгүй байна."}
        />
      )}

      <ConfirmModal
        showModal={visible}
        setShowModal={setVisible}
        submitHandler={submitHandler}
        variant="warning"
        title="Итгэлтэй байна уу?"
        description={"Энэ үйлдлийг буцаах боломжгүйг анхаарна уу!"}
      />
    </Flex>
  );
};

export default LotteryDraw;
